import api from "./api";
const svc = {
  minhas:   ()           => api("GET","/permissoes/minhas"),
  buscar:   (idUsuario)  => api("GET",`/permissoes/${idUsuario}`),
  salvar:   (idUsuario, permissoes) => api("PUT",`/permissoes/${idUsuario}`,{ permissoes }),
};
export default svc;
